import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

export default function BeforeAfter() {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const update = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  };
  const down = (e) => {
    dragging.current = true;
    e.currentTarget.setPointerCapture(e.pointerId);
    update(e.clientX);
  };
  const move = (e) => {
    if (dragging.current) update(e.clientX);
  };
  const up = () => {
    dragging.current = false;
  };

  return (
    <section id="difference" data-testid="before-after-section" className="bg-white py-20 lg:py-28 border-t border-[var(--line)]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-4">
          <Eyebrow>See the difference</Eyebrow>
          <h2 data-testid="before-after-title" className="headline mt-4 text-4xl sm:text-5xl">Before.<br />After.</h2>
          <p className="mt-5 text-[17px] text-[var(--body)] leading-relaxed max-w-sm">Drag the handle to compare. Illustration only — your in-home consultation shows what's actually in your water.</p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-8">
          <div
            ref={ref}
            data-testid="before-after-slider"
            onPointerDown={down}
            onPointerMove={move}
            onPointerUp={up}
            onPointerCancel={up}
            className="relative aspect-[4/3] sm:aspect-[3/2] w-full overflow-hidden bg-[#EBEBEB] select-none touch-none cursor-ew-resize"
          >
            <img src="/img/after.jpg" alt="Glass of clear filtered water" draggable="false" className="absolute inset-0 h-full w-full object-cover" />
            <img src="/img/before.jpg" alt="Glass of cloudy untreated water" draggable="false" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} className="absolute inset-0 h-full w-full object-cover" />
            <span className="absolute top-4 left-4 bg-white px-4 py-2 eyebrow !text-[10px]">Before</span>
            <span className="absolute top-4 right-4 bg-[var(--ink)] px-4 py-2 eyebrow !text-[10px] !text-white">After</span>
            <div style={{ left: `${pos}%` }} className="absolute inset-y-0 -translate-x-1/2 w-[2px] bg-[var(--ink)] pointer-events-none">
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 grid place-items-center h-12 w-12 bg-[var(--ink)] text-white">
                <MoveHorizontal className="h-5 w-5" />
              </span>
            </div>
          </div>
          <input type="range" min="0" max="100" value={Math.round(pos)} onChange={(e) => setPos(Number(e.target.value))} aria-label="Compare before and after" data-testid="before-after-range" className="sr-only" />
        </Reveal>
      </div>
    </section>
  );
}
